import React, { useEffect, useState } from 'react';
import { ConfigRulesByCategory } from './ConfigRulesByCategory';
import { ScrollableContentContainer } from '../components/ScrollableContentContainer';
import { ContentHeader } from '@app/shared';
import { AggregatedConfigRules } from './AggregatedConfigRules';
import { TenantHierarchy } from '@app/models';
import { useCategories } from '@app/sdk';
import { ComponentErrorBoundary } from '@app/utilities';

export function ConfigRulesDetail({
  selectedOu,
  tenantHierarchy,
}: {
  selectedOu: { name: string; id: string };
  tenantHierarchy: TenantHierarchy;
}) {
  const { data: categories } = useCategories();
  const [categoryId, setCategoryId] = useState('all');
  const [categoriesWithAll, setCategoriesWithAll] = useState(categories);
  useEffect(() => {
    if (categories) {
      setCategoriesWithAll([
        {
          id: 'all',
          description: 'All Categories',
          name: 'All Categories',
          type: 'all',
        },
        ...categories,
      ]);
    }
  }, [categories]);

  return (
    <ComponentErrorBoundary>
      <div className={'ui container'} style={{ border: 'thin solid lightgrey', marginBottom: '20px' }}>
        <div style={{ padding: '20px' }}>
          <ContentHeader>Category:</ContentHeader>
          {categoriesWithAll && (
            <select className="ui fluid dropdown" onChange={(e) => setCategoryId(e.target.value)} value={categoryId}>
              {categoriesWithAll?.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.description}
                </option>
              ))}
            </select>
          )}

          <ContentHeader>Rules for {selectedOu?.name}</ContentHeader>
          <ScrollableContentContainer height={'550px'} style={{ padding: '20px', margin: '20px' }}>
            <ConfigRulesByCategory
              ouId={selectedOu?.id}
              categoryId={categoryId}
              categories={categories}
              tenantHierarchy={tenantHierarchy}
            />
          </ScrollableContentContainer>
          <ContentHeader>Aggregated Rules for {selectedOu?.name}</ContentHeader>
          <ScrollableContentContainer height={'550px'} style={{ padding: '20px', margin: '20px' }}>
            <AggregatedConfigRules
              ouId={selectedOu?.id}
              categoryId={categoryId}
              categories={categories}
              tenantHierarchy={tenantHierarchy}
            />
          </ScrollableContentContainer>
        </div>
      </div>
    </ComponentErrorBoundary>
  );
}
